import React, { useState, useEffect, useRef, useCallback } from 'react';
import './App.css';
import PROFILE_PHOTO from "./assets/profile.png";
import faithImg from './assets/faith.png';
import malvarImg from './assets/malvar.jpg';

const NAV_LINKS = [
  { label: 'Home', id: 'home' },
  { label: 'About', id: 'about' },
  { label: 'Education', id: 'education' },
  { label: 'Skills', id: 'skills' },
  { label: 'Projects', id: 'projects' },
  { label: 'Achievements', id: 'achievements' },
  { label: 'Competitions', id: 'competitions' },
  { label: 'Leadership', id: 'leadership' },
  { label: 'Certificates', id: 'certificates' },
  { label: 'Resume', id: 'resume' },
  { label: 'Contact', id: 'contact' },
];

const SKILLS = {
  'Languages': [
    { name: 'C / C++', level: 85 },
    { name: 'Python', level: 80 },
    { name: 'JavaScript', level: 88 },
    { name: 'Java', level: 72 },
    { name: 'VHDL / Verilog', level: 70 },
  ],
  'Web & Frameworks': [
    { name: 'ReactJS', level: 85 },
    { name: 'HTML / CSS', level: 92 },
    { name: 'FastAPI', level: 75 },
    { name: 'Firebase', level: 78 },
    { name: 'Node.js', level: 70 },
  ],
  'Hardware & Tools': [
    { name: 'Arduino / ESP32', level: 88 },
    { name: 'FPGA Design', level: 75 },
    { name: 'Proteus / Multisim', level: 80 },
    { name: 'MATLAB', level: 72 },
    { name: 'Git / GitHub', level: 85 },
  ],
  'Soft Skills': [
    { name: 'Problem Solving', level: 90 },
    { name: 'Teamwork', level: 88 },
    { name: 'Communication', level: 82 },
    { name: 'Leadership', level: 78 },
    { name: 'Adaptability', level: 85 },
  ],
};

const PROJECTS = [
  {
    id: 1,
    title: 'CHEM-QUEST: Hangman Game',
    category: 'PYTHON',
    tech: ['PYTHON', 'GAME DEVELOPMENT', 'EDUCATION'],
    desc: 'Chemistry-themed Hangman game designed to reinforce element and compound knowledge through interactive gameplay.',
    color: '#80c07f',
  },
  {
    id: 2,
    title: 'Sign Language Alphabet Recognition',
    category: 'DIGITAL SYSTEMS',
    tech: ['PYTHON', 'COMPUTER VISION', 'AUDIO FEEDBACK'],
    desc: 'Real-time sign language recognition system with integrated audio feedback to improve accessibility for hearing-impaired users.',
    color: '#8ab7e3',
  },
  {
    id: 3,
    title: 'OTP Email Verification System',
    category: 'WEB DEVELOPMENT',
    tech: ['ReactJS', 'FastAPI', 'FIREBASE', 'Gmail SMTP'],
    desc: 'Full-stack web application with multi-page OTP email verification system. Includes Firestore CRUD, session management, and responsive UI.',
    color: '#d8d858',
  },
  {
    id: 4,
    title: 'Environmental Impact Assessment Tool',
    category: 'ENVIRONMENTAL ENGINEERING',
    tech: ['PYTHON', 'DATA ANALYSIS', 'EIA FRAMEWORK'],
    desc: 'Philippine EIA board review simulation tool for coastal resort development scenarios. Implements DENR guidelines and generates compliance reports.',
    color: '#61e2c0',
  },
  {
    id: 5,
    title: 'Gumball Vending Machine Controller',
    category: 'DIGITAL SYSTEMS',
    tech: ['VHDL', 'FSM', 'VERIFICATIONS'],
    desc: 'Vending machine controller developed and verified using assertion-based verification techniques for digital systems.',
    color: '#e28c6d',
  },
  {
    id: 6,
    title: 'Portfolio Website',
    category: 'Web Development',
    tech: ['ReactJS', 'CSS Animations', 'Liquid Glass UI'],
    desc: 'This very portfolio — built with ReactJS featuring Apple-inspired liquid glass design system, custom cursor, and 60fps animations throughout.',
    color: '#bf5af2',
  },
  {
    id: 7,
    title: 'Automated Egg Incubation System',
    category: 'IOT / EMBEDDED',
    tech: ['ESP32', 'FEEDBACK CONTROL', 'IOT', 'DHT22'],
    desc: 'IoT-enabled incubation system with feedback-controlled temperature regulation and automated ventilation for optimal hatching conditions.',
    color: '#e7657d',
  },
  {
    id: 8,
    title: 'Sift Happens: Real-Time Digital Filtering Device',
    category: 'EMBEDDED SYSTEMS',
    tech: ['SIGNAL PROCESSING', 'EMBEDDED', 'SENSORS'],
    desc: 'Real-time digital filtering system for wind speed sensor data using embedded signal processing techniques.',
    color: '#2fe0e9',
  },
  {
    id: 9,
    title: 'HUNGER',
    category: 'SOFTWARE DESIGN',
    tech: ['WEB DEVELOPMENT', 'UI / UX', 'FULL STACK'],
    desc: 'Full-stack restaurant website with table reservation, online ordering, and a modern dark-themed UI deployed for production use.',
    color: '#000000',
  },
  {
    id: 10,
    title: 'FPGA Pico Park Parody: 4-Player Multiplayer Game',
    category: 'EMBEDDED SYSTEMS',
    tech: ['VHDL', 'ALTERA DE0-CV', 'FPGA', 'GAME DEV'],
    desc: 'FPGA-based parody implementation of Pico Park supporting 4 simultaneous players, built on the Altera DE0-CV board using hardware description logic.',
    color: '#e86edf',
  },
  {
    id: 11,
    title: 'College of Engineering Face Recognition Attendance System',
    category: 'MACHINE LEARNING',
    tech: ['PYTHON', 'OPENCV', 'RFID', 'DATABASE'],
    desc: 'Python-based attendance system integrating facial recognition and RFID with full CRUD database functionality for the College of Engineering.',
    color: '#f69c1f',
  },
  {
    id: 12,
    title: 'ASEAN Lahad 2026',
    category: 'MACHINE LEARNING',
    tech: ['ASEAN', 'YOUTH DEVELOPMENT', 'DIPLOMACY'],
    desc: 'School event where YAD candidates answer critical questions on ASEAN affairs, diplomacy, sustainability, and youth leadership — assessed on analytical thinking, communication, and composure under pressure. Served as Project Head.',
    color: '#471feb',
  },
];

const ACHIEVEMENTS = [
  { year: '2023', title: "CSS-D SCHOLARSHIP", org: 'FAITH Colleges', type: 'Academic' },
  { year: '2026', title: 'ICpEP.se-FC Overall Champion', org: 'College of Engineering', type: 'Extra Curricular' },
  { year: '2026', title: 'Second Best in ECE-FCS | CPE--ES | CPE-MIC Project', org: 'College of Engineering', type: 'Academic' },
];

const COMPETITIONS = [
  { year: '2026', name: 'CLIMATHON: Innovation Challenge', org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter'},
  { year: '2026', name: 'CpElympics 2026',org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter'},
  { year: '2026', name: 'PAPSAS 2026',org: 'First Asia Institute of Technology and Humanities'},
  { year: '2025', name: 'Backend Development',org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter'},
  { year: '2024', name: 'Engineering Cup; Filming', org: 'FAITH Computer Engineering Society'},
  { year: '2023', name: 'Engineering Cup; Filming', org: 'FAITH Computer Engineering Society'}
];

const LEADERSHIP = [
  {
    role: 'Officer Representative',
    org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter',
    year: '2026',
  },
  {
    role: 'Delegate',
    org: 'Philippine Association of Practitioners of Student Affairs and Services (PAPSAS)',
    year: '2026',
  },
  {
    role: 'Youth Advocate',
    org: 'Association of Southeast Asian Nation (ASEAN)',
    year: '2026',
  },
  {
    role: 'Project Lead: ASEAN Lahad',
    org: 'FAITH Student Council',
    year: '2026',
  },
  {
    role: 'Organization Representative',
    org: 'FAITH Student Council',
    year: '2025-2026',
  },
  {
    role: 'Social Media Manager',
    org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter',
    year: '2024-2026',
  },
];

const CERTIFICATES = [
  { title: 'Safety Officer Training (BOSH)', org: 'Department of Labor and Employment (DOLE) Philippines', date: 'Apr 2026' },
  { title: 'ECOVERGENCE 2026', org: 'Society for Environmental Education and Development - SEED of FAITH', date: 'Apr 2026' },
  { title: 'Collaborative Project Presentation and Prototype Exhibition 2026', org: 'College of Engineering', date: 'Apr 2026' },
  { title: 'CpElympics 2026 | Game Changers: Driven by Passion, United by Sport', org: 'Institute of Computer Engineers of the Philippines R4A - Student Edition', date: 'Feb 2026' },
  { title: 'Backend Development Seminar', org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter', date: 'Mar 2026' },
  { title: 'Interactive Youth Forum', org: 'Philippine Association of Practitioners of Student Affairs and Services', date: 'Feb 2026' },
  { title: 'Data Science Seminar', org: 'FAITH Computer Engineering Society', date: 'Nov 2025' },
  { title: 'C Programming Workshop', org: 'FAITH Computer Engineering Society', date: 'Aug 2025' },
  { title: 'Engineering the Future: Career Stories and Industry Insights Seminar', org: 'FAITH Computer Engineering Society', date: 'Mar 2025' },
  { title: 'Building a Sustainable Future Seminar', org: 'FAITH Colleges', date: 'Dec 2024' },
  { title: 'Altium Education Seminar', org: 'FAITH Computer Engineering Society', date: 'Feb 2024' },
  { title: 'Arduino Workshop and Seminar', org: 'Institute of Computer Engineers of the Philippines Student Edition - FAITH Chapter', date: 'Jul 2023' }
];

const SOCIAL = [
  { name: 'Facebook', handle: 'Yuan Tagle', url: 'https://facebook.com/yuanntagle', color: '#1877f2', desc: 'Personal updates & tech content' },
  { name: 'Instagram', handle: 'Y', url: 'https://instagram.com/yuanntagle/', color: '#e1306c', desc: 'Projects, campus life & reels' },
  { name: 'LinkedIn', handle: 'Ren Yuan Angelo Tagle', url: 'https://linkedin.com/in/yuanntagle/', color: '#0077b5', desc: 'Professional network & career' },
  { name: 'GitHub', handle: 'Yuan', url: 'https://github.com/s2023101984-code', color: '#333', desc: 'Open source & repositories' },
];

function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0 });
  const ringPosRef = useRef({ x: 0, y: 0 });
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);
  const rafRef = useRef(null);

  useEffect(() => {
    const move = (e) => {
      posRef.current = { x: e.clientX, y: e.clientY };
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      }
    };
    const animate = () => {
      ringPosRef.current.x += (posRef.current.x - ringPosRef.current.x) * 0.12;
      ringPosRef.current.y += (posRef.current.y - ringPosRef.current.y) * 0.12;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringPosRef.current.x}px, ${ringPosRef.current.y}px)`;
      }
      rafRef.current = requestAnimationFrame(animate);
    };
    const handleClick = () => { setClicked(true); setTimeout(() => setClicked(false), 300); };
    const handleHoverIn = (e) => { if (e.target.closest('button, a, [data-hover]')) setHovered(true); };
    const handleHoverOut = (e) => { if (e.target.closest('button, a, [data-hover]')) setHovered(false); };

    window.addEventListener('mousemove', move, { passive: true });
    window.addEventListener('click', handleClick);
    document.addEventListener('mouseover', handleHoverIn);
    document.addEventListener('mouseout', handleHoverOut);
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('click', handleClick);
      document.removeEventListener('mouseover', handleHoverIn);
      document.removeEventListener('mouseout', handleHoverOut);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className={`cursor-dot ${clicked ? 'cursor-dot--clicked' : ''}`} />
      <div ref={ringRef} className={`cursor-ring ${hovered ? 'cursor-ring--hovered' : ''} ${clicked ? 'cursor-ring--clicked' : ''}`} />
    </>
  );
}

function Navbar({ activeSection, scrollTo, mobileOpen, setMobileOpen }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <button className="navbar__logo" onClick={() => scrollTo('home')}>
          <span className="navbar__logo-mark">RA</span>
        </button>
        <ul className="navbar__links">
          {NAV_LINKS.map(l => (
            <li key={l.id}>
              <button
                className={`navbar__link ${activeSection === l.id ? 'active' : ''}`}
                onClick={() => scrollTo(l.id)}
              >
                {l.label}
                {activeSection === l.id && <span className="navbar__dot" />}
              </button>
            </li>
          ))}
        </ul>
        <button className={`hamburger ${mobileOpen ? 'open' : ''}`} onClick={() => setMobileOpen(o => !o)} aria-label="menu">
          <span /><span /><span />
        </button>
      </nav>
      <div className={`mobile-nav ${mobileOpen ? 'open' : ''}`}>
        {NAV_LINKS.map((l, i) => (
          <button key={l.id} className="mobile-nav__link" onClick={() => scrollTo(l.id)}>
            <span className="mobile-nav__num">0{i + 1}</span>
            {l.label}
          </button>
        ))}
      </div>
    </>
  );
}

function Section({ id, className = '', children }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.08 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return (
    <section id={id} ref={ref} className={`section ${className} ${visible ? 'section--visible' : ''}`}>
      {children}
    </section>
  );
}

function SkillBar({ name, level, delay = 0 }) {
  const [filled, setFilled] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setTimeout(() => setFilled(true), delay); obs.disconnect(); } },
      { threshold: 0.5 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [delay]);
  return (
    <div ref={ref} className="skill-bar">
      <div className="skill-bar__header">
        <span className="skill-bar__name">{name}</span>
        <span className="skill-bar__pct">{level}%</span>
      </div>
      <div className="skill-bar__track">
        <div className="skill-bar__fill" style={{ width: filled ? `${level}%` : '0%', transitionDelay: `${delay}ms` }} />
      </div>
    </div>
  );
}

function GlassCard({ children, className = '', onClick, style }) {
  return (
    <div className={`glass-card ${className}`} onClick={onClick} style={style} data-hover>
      {children}
    </div>
  );
}

function Counter({ value, suffix = '' }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        let start = 0;
        const end = parseFloat(value);
        const step = end / 60;
        const interval = setInterval(() => {
          start += step;
          if (start >= end) { setCount(end); clearInterval(interval); }
          else setCount(parseFloat(start.toFixed(1)));
        }, 16);
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref}>{count}{suffix}</span>;
}

export default function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [skillTab, setSkillTab] = useState('Languages');

  const scrollTo = useCallback((id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  }, []);

  useEffect(() => {
    const fn = () => {
      const pos = window.scrollY + 130;
      for (let i = NAV_LINKS.length - 1; i >= 0; i--) {
        const el = document.getElementById(NAV_LINKS[i].id);
        if (el && el.offsetTop <= pos) { setActiveSection(NAV_LINKS[i].id); break; }
      }
    };
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <div className="app">
      <CustomCursor />
      <div className="orb orb--1" />
      <div className="orb orb--2" />
      <div className="orb orb--3" />
      <div className="orb orb--4" />

      <Navbar activeSection={activeSection} scrollTo={scrollTo} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* HOME */}
      <section id="home" className="hero">
        <div className="hero-chip hero-chip--1"> Computer Engineer</div>
        <div className="hero-chip hero-chip--2"> React Developer</div>
        <div className="hero-chip hero-chip--3"> FPGA / Embedded</div>
        <div className="hero-chip hero-chip--4"> 1000 Followers</div>

        <div className="hero__inner">
          <div className="hero__text">
            <p className="hero__eyebrow">
              <span className="pulse-dot" />
              Available for Internship · FAITH Colleges 
            </p>
            <h1 className="hero__name">
              <span className="hero__name-top">Ren</span>
              <span className="hero__name-bot">Yuan</span>
            </h1>
            <p className="hero__role">
              Computer Engineering Student &amp; <span className="accent-text">Aspiring Engineer</span>
            </p>
            <p className="hero__tagline">
              From silicon to software — I build things that matter.
              FPGA architectures, embedded systems, and full-stack web apps.
              Currently shaping the future, one commit at a time.
            </p>
            <div className="hero__ctas">
              <button className="btn-primary" onClick={() => scrollTo('projects')}>
                <span>View My Work</span>
                <span className="btn-icon">→</span>
              </button>
              <button className="btn-glass" onClick={() => scrollTo('contact')}>
                <span>Let's Connect</span>
              </button>
            </div>
            <div className="hero__social-row">
              {SOCIAL.map(s => (
                <a key={s.name} href={s.url} target="_blank" rel="noreferrer" className="social-pill" data-hover>
                  <span>{s.icon}</span>
                  <span className="social-pill__count">{s.followers}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="hero__visual">
            <div className="hero__photo-rings">
              <div className="ring ring--1" />
              <div className="ring ring--2" />
              <div className="ring ring--3" />
            </div>
            <div className="hero__photo-frame">
              <img src={PROFILE_PHOTO} alt="Ren Yuan" className="hero__photo" />
              <div className="hero__photo-shine" />
              <div className="hero__badge">
                <span className="hero__badge-icon">🎓</span>
                <div>
                  <p className="hero__badge-title">CPE Student</p>
                  <p className="hero__badge-sub">FAITH Colleges</p>
                </div>
              </div>
            </div>
            <div className="float-card float-card--tl">
              <span className="float-card__num"><Counter value={3.2} suffix="+" /></span>
              <span className="float-card__label">GPA</span>
            </div>
            <div className="float-card float-card--br">
              <span className="float-card__num"><Counter value={10} suffix="+" /></span>
              <span className="float-card__label">Projects</span>
            </div>
          </div>
        </div>

        <div className="hero__scroll">
          <div className="scroll-track"><div className="scroll-thumb" /></div>
          <span>Scroll to explore</span>
        </div>
      </section>

      {/* ABOUT */}
      <Section id="about" className="about-section">
        <div className="section__header">
          <p className="section__eyebrow">01 — Who I Am</p>
          <h2 className="section__title">About <span className="accent-text">Me</span></h2>
        </div>
        <div className="about__grid">
          <GlassCard className="about__story">
            <p className="about__intro">
              Hey! I'm <strong>Ren Yuan Angelo Tagle</strong>, a Junior Computer Engineering student at
              FAITH Colleges: First Asia Institute of Technology and Humanities in the Philippines. 
              I'm obsessed with the intersection of hardware and software — where digital logic meets real-world impact.
            </p>
            <p className="about__body">
              My journey started with curiosity about how computers actually work at the
              transistor level. That curiosity grew into a full-on passion for embedded
              systems, FPGA design, and building web applications that solve real problems.
            </p>
            <p className="about__body">
              Outside of engineering, I'm active on social media and currently the Social Media Manager for my university's computer engineering society, sharing my projects and
              learning journey, with a combined following of <strong>1000+</strong> across platforms.
              I believe great engineers also communicate — building communities, not just circuits.
            </p>
            <div className="about__tags">
              {['Web Developer', 'Community Builder', 'Lifelong Learner', 'Code Enthusiast'].map(t => (
                <span key={t} className="tag">{t}</span>
              ))}
            </div>
          </GlassCard>
          <div className="about__stats-col">
            {[
              { num: '1000+', label: 'Social Followers'},
              { num: '10+', label: 'Projects Built'},
              { num: '10+', label: 'Groups Led'},
              { num: '3+', label: 'Years Engineering'},
            ].map(s => (
              <GlassCard key={s.label} className="about__stat-card">
                <span className="about__stat-icon">{s.icon}</span>
                <span className="about__stat-num">{s.num}</span>
                <span className="about__stat-label">{s.label}</span>
              </GlassCard>
            ))}
          </div>
        </div>
      </Section>

      {/* EDUCATION */}
<Section id="education" className="education-section alt-bg">
  <div className="section__header">
    <p className="section__eyebrow">02 — Academic Journey</p>
    <h2 className="section__title">Edu<span className="accent-text">cation</span></h2>
  </div>
  <div className="education__timeline">
    {[
      {
        period: '2023 — Present',
        degree: 'First Asia Institute of Technology and Humanities',
        school: 'Bachelor of Science in Computer Engineering',
        detail: 'School of Technology · College of Engineering · Junior Year',
        current: true,
        image: faithImg,
        highlights: ['CPE--DS', 'CPE--ES', 'CPE-MIC', 'CPE-MIC2', 'ECE-FCS'],
      },
      {
        period: '2021 — 2023',
        degree: 'Malvar Senior High School, Malvar Batangas',
        school: 'Senior High School — STEM Strand',
        detail: 'Science, Technology, Engineering and Mathematics Track',
        current: false,
        image: malvarImg,
        highlights: ['PHY', 'CHE', 'CAL', 'EIM', '3IS'],
      },
    ].map((edu, i) => (
      <div key={i} className={`edu-card glass-card ${edu.current ? 'edu-card--current' : ''}`}>
        {edu.current && <div className="edu-card__badge">Current</div>}

        {/* School image */}
        <div className="edu-card__image-wrap">
          <img src={edu.image} alt={edu.school} className="edu-card__image" />
        </div>

        {/* Content */}
        <div className="edu-card__content">
          <div className="edu-card__header-row">
            <span className="edu-card__icon">{edu.icon}</span>
            <p className="edu-card__period">{edu.period}</p>
          </div>
          <h3 className="edu-card__degree">{edu.degree}</h3>
          <p className="edu-card__school">{edu.school}</p>
          <p className="edu-card__detail">{edu.detail}</p>
          <div className="edu-card__highlights">
            {edu.highlights.map(h => <span key={h} className="tag tag--sm">{h}</span>)}
          </div>
        </div>
      </div>
    ))}
  </div>
</Section>

      {/* SKILLS */}
      <Section id="skills" className="skills-section">
        <div className="section__header">
          <p className="section__eyebrow">03 — What I Know</p>
          <h2 className="section__title">My <span className="accent-text">Skills</span></h2>
        </div>
        <div className="skill-tabs">
          {Object.keys(SKILLS).map(tab => (
            <button key={tab} className={`skill-tab ${skillTab === tab ? 'active' : ''}`} onClick={() => setSkillTab(tab)} data-hover>
              {tab}
            </button>
          ))}
        </div>
        <GlassCard className="skills__panel">
          {SKILLS[skillTab].map((s, i) => (
            <SkillBar key={`${skillTab}-${s.name}`} name={s.name} level={s.level} delay={i * 80} />
          ))}
        </GlassCard>
      </Section>

      {/* PROJECTS */}
      <Section id="projects" className="projects-section alt-bg">
        <div className="section__header">
          <p className="section__eyebrow">04 — What I've Built</p>
          <h2 className="section__title">Pro<span className="accent-text">jects</span></h2>
        </div>
        <div className="projects__grid">
          {PROJECTS.map((p, i) => (
            <GlassCard key={p.id} className="project-card" style={{ '--card-color': p.color, animationDelay: `${i * 0.1}s` }}>
              <div className="project-card__top">
                <span className="project-card__emoji">{p.emoji}</span>
                <span className="project-card__cat">{p.category}</span>
              </div>
              <h3 className="project-card__title">{p.title}</h3>
              <p className="project-card__desc">{p.desc}</p>
              <div className="project-card__tech">
                {p.tech.map(t => <span key={t} className="tech-tag">{t}</span>)}
              </div>
              <div className="project-card__glow" style={{ background: p.color }} />
            </GlassCard>
          ))}
        </div>
      </Section>

      {/* ACHIEVEMENTS */}
      <Section id="achievements" className="achievements-section">
        <div className="section__header">
          <p className="section__eyebrow">05 — Recognition</p>
          <h2 className="section__title">Achieve<span className="accent-text">ments</span></h2>
        </div>
        <div className="achievements__list">
          {ACHIEVEMENTS.map((a, i) => (
            <GlassCard key={i} className="achieve-card">
              <div className="achieve-card__left">
                <span className="achieve-card__icon">{a.icon}</span>
                <div>
                  <h3 className="achieve-card__title">{a.title}</h3>
                  <p className="achieve-card__org">{a.org}</p>
                </div>
              </div>
              <div className="achieve-card__right">
                <span className="achieve-card__type">{a.type}</span>
                <span className="achieve-card__year">{a.year}</span>
              </div>
            </GlassCard>
          ))}
        </div>
      </Section>

      {/* COMPETITIONS */}
      <Section id="competitions" className="competitions-section alt-bg">
        <div className="section__header">
          <p className="section__eyebrow">06 — Battles Won</p>
          <h2 className="section__title">Compe<span className="accent-text">titions</span></h2>
        </div>
        <div className="competitions__grid">
          {COMPETITIONS.map((c, i) => (
            <GlassCard key={i} className="comp-card">
              <div className="comp-card__header">
                <span className="comp-card__icon">{c.icon}</span>
                <span className="comp-card__year">{c.year}</span>
              </div>
              <h3 className="comp-card__name">{c.name}</h3>
              <p className="comp-card__org">{c.org}</p>
              <div className="comp-card__footer">
                <span className="comp-card__role">{c.role}</span>
                <span className="comp-card__award">{c.award}</span>
              </div>
            </GlassCard>
          ))}
        </div>
      </Section>

      {/* LEADERSHIP */}
      <Section id="leadership" className="leadership-section">
        <div className="section__header">
          <p className="section__eyebrow">07 — Leading the Way</p>
          <h2 className="section__title">Leader<span className="accent-text">ship</span></h2>
        </div>
        <div className="leadership__grid">
          {LEADERSHIP.map((l, i) => (
            <GlassCard key={i} className="leader-card">
              <div className="leader-card__icon">{l.icon}</div>
              <h3 className="leader-card__role">{l.role}</h3>
              <p className="leader-card__org">{l.org}</p>
              <p className="leader-card__year">{l.year}</p>
              <p className="leader-card__desc">{l.desc}</p>
            </GlassCard>
          ))}
        </div>
      </Section>

      {/* CERTIFICATES */}
      <Section id="certificates" className="certificates-section alt-bg">
        <div className="section__header">
          <p className="section__eyebrow">08 — Verified Learning</p>
          <h2 className="section__title">Certifi<span className="accent-text">cates</span></h2>
        </div>
        <div className="certs__grid">
          {CERTIFICATES.map((c, i) => (
            <GlassCard key={i} className="cert-card" style={{ '--cert-color': c.color }}>
              <div className="cert-card__bar" style={{ background: c.color }} />
              <div className="cert-card__body">
                <h3 className="cert-card__title">{c.title}</h3>
                <p className="cert-card__org">{c.org}</p>
                <p className="cert-card__date">{c.date}</p>
              </div>
              <div className="cert-card__seal">✓</div>
            </GlassCard>
          ))}
        </div>
      </Section>

      {/* RESUME */}
      <Section id="resume" className="resume-section">
        <div className="section__header">
          <p className="section__eyebrow">09 — Full Picture</p>
          <h2 className="section__title">My <span className="accent-text">Resume</span></h2>
        </div>
        <GlassCard className="resume-card">
          <div className="resume-card__left">
            <div className="resume-card__avatar">
              <img src={PROFILE_PHOTO} alt="Ren Yuan Angelo" />
            </div>
            <div>
              <h3 className="resume-card__name">Ren Yuan</h3>
              <p className="resume-card__title-text">BS Computer Engineering · FAITH Colleges</p>
              <div className="resume-card__pills">
                <span className="tag">CPE 3A</span>
                <span className="tag">CPE -- DS | Software Design </span>
              </div>
            </div>
          </div>
          <div className="resume-card__actions">
            <a href="/Tagle_Resume.pdf" className="btn-primary" download data-hover><span>📄 Download PDF</span></a>
            <a href="https://www.canva.com/design/DAHE2vDjHf4/DEE5Yd2LGyz7z3MwgEmS4w/edit?utm_content=DAHE2vDjHf4&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton" className="btn-glass" target="_blank" rel="noreferrer" data-hover><span>👁 View Online</span></a>
          </div>
        </GlassCard>
        <div className="resume-preview">
          <div className="resume-preview__col">
            <h4 className="resume-preview__heading">Internal Experience Snapshot</h4>
            {[
              { title: 'Organization Representative', org: 'FAITH Student Council', year: '2025–26' },
              { title: 'Social Media Manager', org: 'Institute of Computer Engineers of the Philippine Student Edition - FAITH Chapter', year: '2024–Present' },
            ].map((e, i) => (
              <GlassCard key={i} className="resume-item">
                <div className="resume-item__dot" />
                <div>
                  <p className="resume-item__title">{e.title}</p>
                  <p className="resume-item__org">{e.org}</p>
                  <p className="resume-item__year">{e.year}</p>
                </div>
              </GlassCard>
            ))}
          </div>
          <div className="resume-preview__col">
            <h4 className="resume-preview__heading">External Education Snapshot</h4>
            {[
              { title: 'Youth Advocate', org: 'Association of Southeast Asian Nation (ASEAN)', year: '2026'},
              { title: 'Delegate', org: 'Philippine Association of Practitioners of Student Affairs and Services (PAPSAS)', year: '2026'},
            ].map((e, i) => (
              <GlassCard key={i} className="resume-item">
                <div className="resume-item__dot" />
                <div>
                  <p className="resume-item__title">{e.title}</p>
                  <p className="resume-item__org">{e.org}</p>
                  <p className="resume-item__year">{e.year}</p>
                </div>
              </GlassCard>
            ))}
          </div>
        </div>
      </Section>

      {/* CONTACT */}
      <Section id="contact" className="contact-section alt-bg">
        <div className="section__header">
          <p className="section__eyebrow">10 — Let's Talk</p>
          <h2 className="section__title">Get In <span className="accent-text">Touch</span></h2>
        </div>
        <div className="social-cards">
          {SOCIAL.map((s, i) => (
            <a key={s.name} href={s.url} target="_blank" rel="noreferrer"
              className="social-card" style={{ '--sc-color': s.color }} data-hover>
              <div className="social-card__top">
                <span className="social-card__icon">{s.icon}</span>
                <div className="social-card__followers">
                  <span className="social-card__count">{s.followers}</span>
                </div>
              </div>
              <h3 className="social-card__name">{s.name}</h3>
              <p className="social-card__handle">{s.handle}</p>
              <p className="social-card__desc">{s.desc}</p>
              <div className="social-card__cta">Follow →</div>
              <div className="social-card__glow" style={{ background: s.color }} />
            </a>
          ))}
        </div>
        <div className="contact__wrapper">
          <GlassCard className="contact-info">
            <h3 className="contact-info__title">Direct Contact</h3>
            <div className="contact-info__items">
              {[
                { label: 'Email', value: 's2023101984@firstasia.edu.ph', href: 's2023101984@firstasia.edu.ph' },
                { label: 'Phone', value: '+63 926 513 0758', href: 'tel:+639265130758' },
                { label: 'Location', value: 'Malvar, Batangas Philippines', href: null },
              ].map(item => (
                <div key={item.label} className="contact-info__item">
                  <span className="contact-info__icon">{item.icon}</span>
                  <div>
                    <p className="contact-info__label">{item.label}</p>
                    {item.href
                      ? <a href={item.href} className="contact-info__value accent-text">{item.value}</a>
                      : <p className="contact-info__value">{item.value}</p>}
                  </div>
                </div>
              ))}
            </div>
          </GlassCard>
          <GlassCard className="contact-form">
            <h3 className="contact-form__title">Send a Message</h3>
            <div className="form-group">
              <label className="form-label">Name</label>
              <input className="form-input" type="text" placeholder="Your full name" />
            </div>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input className="form-input" type="email" placeholder="your@email.com" />
            </div>
            <div className="form-group">
              <label className="form-label">Message</label>
              <textarea className="form-input form-input--textarea" placeholder="What's on your mind?" rows={4} />
            </div>
            <button className="btn-primary btn-full" data-hover>
              <span>Send Message </span>
            </button>
          </GlassCard>
        </div>
      </Section>

      <footer className="footer">
        <p className="footer__copy">© 2026 · Ren Yuan Angelo · BSCPE · First Asia Institute of Technology and Humanities</p>
        <div className="footer__links">
          {SOCIAL.map(s => (
            <a key={s.name} href={s.url} target="_blank" rel="noreferrer" className="footer__link" data-hover>{s.icon}</a>
          ))}
        </div>
        <button className="footer__top" onClick={() => scrollTo('home')} data-hover>↑ Top</button>
      </footer>
    </div>
  );
}
